/* eslint-disable no-console */
/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component, Fragment } from "react";
import "./PersonalDetails.css";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
//import moment from 'moment';
import errorMsg from "../../assets/json/errMsg.json";
import { checkEmail } from "../../assets/validators/common.js";
import { simpleFetch } from "../../restWrapper";
import { DONOR_AUTH } from "../../config.js";
import { resolveThemeColors, withoutExpressPaymentAuthorisation, formatWalletPaymentMethod } from "../../assets/helper.js";
import { getProjectTitle } from "../../assets/projectTitleHelper.js";
import hkRegions, { getDistrictsByRegion, getLabel, countryList } from "../../assets/hkAddressData.js";

import "react-phone-number-input/style.css";
import PhoneInput, {
  isValidPhoneNumber,
} from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

import PropTypes from "prop-types";

import { Helmet } from "react-helmet";
import { ENV, PLATFORM } from "../../config.js";
import checkplusLogo from "../../assets/component/images/checkplus-logo.svg";
import plugLogo from "../../assets/component/images/plug-logo.svg";

class PersonalDetails extends Component {
  constructor(props) {
    super(props);

    try {

      if (
        this.props.location.state === null ||
        this.props.location.state === undefined
      ) {
        this.props.history.push("/SelectMission");
      }
      //      let donorInfo = this.props.location.state.donorInfo;
      //      let registerInfo = this.props.location.state.registerInfo;

      let donorInfo = {
        firstName: "",
        lastName: "",
        orgName: "",
        email: "",
        memo: "",
        phoneNumber: "",
      };

      if (ENV === 'local' || ENV === 'dev') {
        donorInfo = {
          firstName: "",
          lastName: "",
          orgName: "",
          email: "",
          memo: "",
          phoneNumber: "",
        };
      }

      // Check if user was authenticated in a previous step
      const wasAuthenticated = this.props.location.state &&
                               (this.props.location.state.userAuthenticated ||
                                this.props.location.state.isAuth);

      if (wasAuthenticated) {
        // console.log("User was authenticated in previous navigation, preserving auth state");
      }

      this.state = {
        ...{
          isPersonalDonation: true,
          confirmEmail: "",
          confirmPassword: "",
          buttonClick: false,
          createAccount: false,
          authMode: 'signup', // 'signup' or 'login'
          loginEmail: "",
          loginPassword: "",
          loginAttempted: wasAuthenticated || false,  // Preserve authentication state
          emailCheckComplete: false,
          existingAccountDetected: false,
          showLoginSuggestion: false,
          showOptionalAuth: true, // For non-recurring, can dismiss account creation
          // New seamless verification flow
          verificationCodeSent: false,
          verificationCode: "",
          verificationInProgress: false,
          verificationComplete: false,
          registrationInProgress: false,
          // Full-screen overlay for authentication
          showAuthOverlay: false,
          language: this.props.language,
          donorInfo,
          registerInfo: {
            pw: "",
            rePw: "",
            phoneNo: "852",
            ageGroup: "",
            currency: "hkd",
            flatAndFloorNumber: "",
            building: "",
            street: "",
            town: "",
            country: "",
            birthdayMonth: "",
            birthdayDayInMonth: "",
            educationLevel: "",
          },
          customFields: {},
          errorMsg: {},
        },
        ...this.props.location.state,
      };
    } catch (e) {
      this.props.history.push({
        pathname: "/SelectMission",
      });
    }

    this.onBackBtnClicked = this.onBackBtnClicked.bind(this);
    this.handleFirstName = this.setDonorInfoData.bind(this, "firstName");
    this.handleLastName = this.setDonorInfoData.bind(this, "lastName");
    this.handleOrgName = this.setDonorInfoData.bind(this, "orgName");
    this.handleEmail = this.setDonorInfoData.bind(this, "email");
    this.handConfirmEmail = this.setConfirmEmail.bind(this);
    this.handConfirmPassword = this.setConfirmPassword.bind(this);
    this.handleMemo = this.setDonorInfoData.bind(this, "memo");
    this.handlePhoneNumber = this.setDonorInfoData.bind(this, "phoneNumber");
    this.handlePw = this.setRegisterInfoData.bind(this, "pw");
    this.handleRePw = this.setRegisterInfoData.bind(this, "rePw");
    this.onNextBtnClicked = this.onNextBtnClicked.bind(this);
    this.toggleCreateAccount = this.toggleCreateAccount.bind(this);
    this.toggleAuthMode = this.toggleAuthMode.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleLoginEmail = this.handleLoginEmail.bind(this);
    this.handleLoginPassword = this.handleLoginPassword.bind(this);

    this.onChangePaymentMethodClicked = this.onChangePaymentMethodClicked.bind(this);
    this.handleCustomFields = this.handleCustomFields.bind(this);
    this.handleCustomFieldToggle = this.handleCustomFieldToggle.bind(this);
    this.handleCustomFieldAddress = this.handleCustomFieldAddress.bind(this);
    this.checkEmailExists = this.checkEmailExists.bind(this);
    this.handleLoginSuggestionAccept = this.handleLoginSuggestionAccept.bind(this);
    this.handleLoginSuggestionDecline = this.handleLoginSuggestionDecline.bind(this);

    // New seamless verification methods
    this.handleSeamlessRegistration = this.handleSeamlessRegistration.bind(this);
    this.handleVerificationCodeChange = this.handleVerificationCodeChange.bind(this);
    this.handleVerificationCodeSubmit = this.handleVerificationCodeSubmit.bind(this);
    this.closeAuthOverlay = this.closeAuthOverlay.bind(this);
    this.proceedToPayment = this.proceedToPayment.bind(this);
  }

  componentDidMount() {
    this.setState({
      isScrolling: false,
    });
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.onScroll);

    // Auto-enable account creation for recurring payments
    this.checkRecurringRequiresAuth();

    // Fetch user profile if authenticated
    if (this.props.isAuth) {
      this.fetchUserProfile();
    }
  }

  hasOrgCustomFields() {
    const fs = this.props.location.state
      && this.props.location.state.organization
      && this.props.location.state.organization.formSetting;
    if (!fs || !fs.enabled || !Array.isArray(fs.rows)) return false;
    return fs.rows.some((f) => f && !f.internal && !f.archived);
  }

  fetchUserProfile() {
    // console.log("Fetching user profile to populate personal details...");
    // console.log("JWT token in localStorage before fetchUserProfile:", localStorage.getItem("accessToken") ? "EXISTS" : "MISSING");
    return simpleFetch("/donors", "GET", {}, false)
      .then((res) => {
        // console.log("fetchUserProfile response status:", res.status);
        if (res.status === 200 && res.body) {
          // console.log("Fetched user profile:", res.body);

          // Format phone number if it exists
          let formattedPhoneNumber = this.state.donorInfo.phoneNumber;
          if (res.body.phoneNumber) {
            // If phoneNumber doesn't start with +, try to format it
            formattedPhoneNumber = res.body.phoneNumber.startsWith('+')
              ? res.body.phoneNumber
              : `+${res.body.phoneNumber}`;
          }

          // Resolve only after setState flushes so callers chaining off this
          // promise see the populated donorInfo.
          return new Promise((resolve) => {
            this.setState({
              donorInfo: {
                ...this.state.donorInfo,
                firstName: res.body.firstName || this.state.donorInfo.firstName,
                lastName: res.body.lastName || this.state.donorInfo.lastName,
                email: res.body.username || this.state.donorInfo.email,
                phoneNumber: formattedPhoneNumber,
              }
            }, () => {
              // console.log("User profile populated successfully:", {
              // firstName: res.body.firstName,
              // lastName: res.body.lastName,
              // phoneNumber: formattedPhoneNumber
              // });
              resolve(res);
            });
          });
        }
        return res;
      })
      .catch((error) => {
        //console.error("Failed to fetch user profile:", error);
        throw error; // Re-throw to allow caller to handle
      });
  }

  componentWillUnmount() {
    // Clear email check timeout to prevent memory leaks
    if (this.emailCheckTimeout) {
      clearTimeout(this.emailCheckTimeout);
    }
    // Remove scroll event listener
    window.removeEventListener("scroll", this.onScroll);
  }

  // Helper method to check if current transaction is recurring
  isRecurringTransaction() {
    const isRecurringFrequency = this.state.frequency && this.state.frequency !== "ONETIME";
    return isRecurringFrequency && ((this.state.recurringOccurrences && this.state.recurringOccurrences > 0) || this.state.isInfiniteRecurring);
  }

  checkRecurringRequiresAuth() {
    const isRecurringPayment = this.isRecurringTransaction();
    if (isRecurringPayment && !this.props.isAuth) {
      // Auto-enable account creation for signup mode
      if (this.state.authMode === 'signup' && !this.state.createAccount) {
        this.setState({
          createAccount: true,
          errorMsg: {
            ...this.state.errorMsg,
            recurringAuth: ""
          }
        });
      }
    } else if (!isRecurringPayment && this.state.createAccount) {
      // Reset createAccount to false for one-time payments
      // This handles the case where user navigated back and changed from recurring to one-time
      this.setState({
        createAccount: false
      });
    }
  }

  setConfirmEmail(e) {
    let err = this.state.errorMsg;
    err["confirmEmail"] = "";
    this.setState({
      errorMsg: err,
      confirmEmail: e.target.value,
    });
  }

  setConfirmPassword(e) {
    let err = this.state.errorMsg;
    err["confirmPassword"] = "";
    this.setState({
      errorMsg: err,
      confirmPassword: e.target.value,
    });
  }

  setDonorInfoData(name, e) {
    let data = this.state.donorInfo;
    const value = e.target.value; // Capture value before setTimeout
    data[name] = value;
    let err = this.state.errorMsg;
    err[name] = "";
    this.setState({
      errorMsg: err,
      donorInfo: data,
    });

    // For email field, check if account exists (with debouncing)
    if (name === 'email') {
      // Clear previous timeout
      if (this.emailCheckTimeout) {
        clearTimeout(this.emailCheckTimeout);
      }

      // Reset email detection state
      this.setState({
        emailCheckComplete: false,
        existingAccountDetected: false,
        showLoginSuggestion: false
      });

      // Set new timeout for email checking
      this.emailCheckTimeout = setTimeout(() => {
        this.checkEmailExists(value); // Use captured value
      }, 800); // Wait 800ms after user stops typing
    }
  }

  setRegisterInfoData(name, e) {
    let data = this.state.registerInfo;
    data[name] = e.target.value;

    // Auto-enable account creation when password is entered for recurring donations
    const isRecurringPayment = this.isRecurringTransaction();
    if (name === 'pw' && e.target.value && isRecurringPayment && !this.state.createAccount) {
      this.setState({
        registerInfo: data,
        createAccount: true
      });
    } else {
      this.setState({
        registerInfo: data,
      });
    }
  }

  onBackBtnClicked() {
    // If this is a quick payment flow or no-project flow, go back to SelectMission
    if (this.state.isQuickPaymentFlow || this.state.isNoProjectFlow) {
      this.props.history.push({
        pathname: "/SelectMission"
      });
    } else if (this.state.mission) {
      // Pass the complete state when going back to MissionDetails
      this.props.history.push({
        pathname: "/MissionDetails",
        search: "?no=" + this.state.mission.id,
        state: this.state // Pass the complete state
      });
    } else {
      // Fallback to SelectMission if no mission is found
      this.props.history.push({
        pathname: "/SelectMission"
      });
    }
  }

  isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

  onNextBtnClicked(e) {
    e.preventDefault();
    this.setState({
      buttonClick: true,
    });
    var err = {};
    var errMsg = errorMsg[this.props.language].donorInfoErr;

    // Debug logging
    // console.log("=== DEBUG: Next button clicked ===");
    // console.log("isAuth (prop):", this.props.isAuth);
    // console.log("loginAttempted (state):", this.state.loginAttempted);
    // console.log("recurringOccurrences:", this.state.recurringOccurrences);
    // console.log("donorInfo:", this.state.donorInfo);

    const cardPaymentsStatus = this.props.location.state && this.props.location.state.cardPaymentsStatus;
    const transfersStatus = this.props.location.state && this.props.location.state.transfersStatus;

    const charges_enabled = this.props.location.state && this.props.location.state.charges_enabled;
    
    // For QuickPayment flow, ensure we have at least one valid donation
    if (this.state.isQuickPaymentFlow && this.state.donations && this.state.donations.length === 0) {
      err.donations = "Please select at least one project to donate to";
    }

    // For recurring payments, authentication is required
    const isRecurringPayment = this.isRecurringTransaction();
    const isAuthenticated = this.props.isAuth || this.state.loginAttempted || this.state.verificationComplete;

    // NEW: For recurring payments without authentication, show the overlay instead of validation errors
    if (isRecurringPayment && !isAuthenticated) {
      // First validate that basic fields are filled
      const namesFilled = this.state.isPersonalDonation
        ? (this.state.donorInfo.firstName && this.state.donorInfo.lastName)
        : !!this.state.donorInfo.orgName;
      if (!namesFilled || !this.state.donorInfo.email || !this.state.donorInfo.phoneNumber) {
        // Will be caught by field validation below
      } else {
        // All fields are filled, show the auth overlay
        this.setState({
          buttonClick: false,
          showAuthOverlay: true
        });
        return;
      }
    }

    if (this.state.isPersonalDonation && !this.state.donorInfo.firstName) {
      err.firstName = errMsg.firstName;
    }

    if (!this.state.isPersonalDonation && !this.state.donorInfo.orgName) {
      err.orgName = errorMsg[this.props.language].orgInfoErr.orgNameErr;
    }

    if (this.state.isPersonalDonation && !this.state.donorInfo.lastName) {
      err.lastName = errMsg.lastName;
    }
    
    // Ensure country is set, default to HK if not provided
    if (!this.state.country) {
      this.setState({ country: "HK" });
    }

    // Password validation
    const pass = this.state.registerInfo.pw;
    const confirmPass = this.state.confirmPassword;
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])[0-9a-zA-Z]{8,}$/;

    // Skip password validation if user has successfully logged in
    const userLoggedIn = this.state.loginAttempted;

    if (this.state.createAccount && !userLoggedIn) {
      // Validate password when creating an account (but not if user logged in)
      if (!pass || pass.length === 0) {
        err.pw = "Password is required";
      } else if (pass.length < 8) {
        err.pw = "Password must be at least 8 characters";
      } else if (!passwordRegex.test(pass)) {
        err.pw = "Password must include letters and numbers";
      }

      // Validate confirm password
      if (!confirmPass || confirmPass.length === 0) {
        err.confirmPassword = "Please confirm your password";
      } else if (confirmPass !== pass) {
        err.confirmPassword = "Passwords do not match";
      }
    } else if (pass.length !== 0) {
      // If not creating an account but password was entered, still validate it
      if (pass.length < 8) {
        err.pw = "Password must be at least 8 characters";
      } else if (!passwordRegex.test(pass)) {
        err.pw = "Password must include letters and numbers";
      }
    }

    if (!isValidPhoneNumber(this.state.donorInfo.phoneNumber)) {
      err.phoneNumber = errMsg.phoneNumber;
    }

    const email = this.state.donorInfo.email;
    const confirmEmail = this.state.confirmEmail;

    if (!email || !checkEmail(email)) {
      err.email = errorMsg[this.props.language].loginErr.loginEmailErr;
    }

    // Email confirmation validation only for recurring payments (handled in inline form)
    // For non-recurring, we don't require email confirmation anymore
    // Note: isRecurringPayment already declared above at line 313

    if (isRecurringPayment && !this.props.isAuth && !userLoggedIn && !this.state.existingAccountDetected) {
      // Validate confirm email for recurring donations creating new accounts
      if (
        !confirmEmail ||
        !checkEmail(confirmEmail) ||
        confirmEmail !== email
      ) {
        err.confirmEmail =
          errorMsg[this.props.language].loginErr.loginConfirmEmailErr;
      }
    }

    // custom fields validation

    const customFields = this.props.location.state && this.props.location.state.organization && this.props.location.state.organization.formSetting;

    if (customFields && customFields.enabled && customFields.rows.length > 0) {
      customFields.rows.forEach((field) => {
        // Skip internal-only and archived fields for donor validation
        if (field.internal || field.archived) return;

        const fieldValue = this.state.customFields[field.id] ? this.state.customFields[field.id].value : "";

        if (field.required) {
          if (field.type === 'address') {
            let parsed = {};
            try { parsed = JSON.parse(fieldValue || '{}'); } catch (e) { parsed = {}; }
            const isHK = (parsed.country || 'Hong Kong') === 'Hong Kong';
            const isInvalid = isHK ? !parsed.flat : !parsed.address1;
            if (isInvalid) {
              err[field.id] = `${field.i18n.label[this.props.language]} is required`;
            }
          } else if (fieldValue === "") {
            err[field.id] = `${field.i18n.label[this.props.language]} is required`;
          }
        }
      });
    }

    this.setState({
      errorMsg: err,
    });

    // Debug logging for validation errors
    // console.log("Validation errors:", err);
    // console.log("Is err empty?", this.isEmpty(err));

    if (this.isEmpty(err)) {
      /* Only if Email is filled */
      // if (email) {
      //   let reply = window.confirm(
      //     "Would you like to Sign Up with the given email?"
      //   );
      //   if (reply) {
      //     console.log("Registering...");
      //   }
      // }

      // Create a copy of the state to avoid direct mutations
      const updatedState = { ...this.state };
      
      // Validate and ensure organization has complete data
      if (!updatedState.organization) {
        // console.error("Organization object is missing in PersonalDetails");
        updatedState.organization = {
          headerColor: "000000",
          buttonColor: "ffffff",
          organizationName: "Organization",
          logo: {},
          paymentMethodCode: {}
        };
      } else if (!updatedState.organization.paymentMethodCode) {
        // console.warn("paymentMethodCode is missing in organization, using empty object");
        updatedState.organization.paymentMethodCode = {};
      }
      
      // Ensure all required organization properties exist
      const requiredProps = [
        "headerColor", "buttonColor", "organizationName", "logo", 
        "paymentMethodCode", "currentPlan"
      ];
      
      requiredProps.forEach(prop => {
        if (!updatedState.organization[prop]) {
          // console.warn(`Organization missing ${prop}, adding default value`);
          
          // Set default values based on property
          switch(prop) {
            case "headerColor":
              updatedState.organization.headerColor = "000000";
              break;
            case "buttonColor":
              updatedState.organization.buttonColor = "ffffff";
              break;
            case "organizationName":
              updatedState.organization.organizationName = "Organization";
              break;
            case "logo":
              updatedState.organization.logo = {};
              break;
            case "paymentMethodCode":
              updatedState.organization.paymentMethodCode = {};
              break;
            case "currentPlan":
              updatedState.organization.currentPlan = "basic";
              break;
            default:
              break;
          }
        }
      });

      // For QuickPayment flow, ensure we have a valid mission object
      if (updatedState.isQuickPaymentFlow && (!updatedState.mission || !updatedState.mission.title)) {
        // console.log("Setting default mission for QuickPayment flow");
        updatedState.mission = {
          id: "no-project", // Standardized to match NoProject flow
          title: "Quick Payment",
          status: "unlisted",
          donation: true
        };
      }

      // For NoProject flow, ensure we have a valid mission object
      if (updatedState.isNoProjectFlow && (!updatedState.mission || !updatedState.mission.title)) {
        updatedState.mission = {
          id: "no-project", // Consistent with QuickPayment
          title: updatedState.transactionType === 'donation'
            ? `Donation to ${(updatedState.organization && updatedState.organization.organizationName) || "Organization"}`
            : `Payment to ${(updatedState.organization && updatedState.organization.organizationName) || "Organization"}`,
          status: "unlisted",
          donation: updatedState.transactionType === 'donation'
        };
      }

      // Create a complete state object with all necessary data
      // Include authentication status for saved cards to work
      const isAuthenticated = this.props.isAuth || this.state.loginAttempted || this.state.verificationComplete;

      // Remove legacy and sensitive fields that should not be passed to subsequent pages
      // - createAccount: no longer used since users authenticate in PersonalDetails before proceeding
      // - registerInfo: contains password (pw) which should never be passed through router state
      // - confirmPassword/confirmEmail: validation fields only used in PersonalDetails
      // - loginEmail/loginPassword: only used for login within PersonalDetails
      const {
        createAccount: _createAccount,
        registerInfo: _registerInfo,
        confirmPassword: _confirmPassword,
        confirmEmail: _confirmEmail,
        loginEmail: _loginEmail,
        loginPassword: _loginPassword,
        ...stateWithoutSensitiveFields
      } = updatedState;

      const completeState = {
        ...stateWithoutSensitiveFields,
        payerType: this.state.isPersonalDonation ? 'individual' : 'company',
        cardPaymentsStatus: cardPaymentsStatus,
        transfersStatus: transfersStatus,
        charges_enabled: charges_enabled,
        isAuth: isAuthenticated,  // Pass authentication status
        userAuthenticated: isAuthenticated,  // Additional flag for navigation
      };

      // console.log(`PersonalDetails - transactionType in completeState: ${completeState.transactionType}`); // Removed log
      const destination = this.getPaymentDestination();
      // console.log("Navigating to", destination, "with state:", JSON.stringify(completeState));
      // console.log("Authentication status being passed on:", isAuthenticated);

      // If user just logged in or verified, wait a moment for AuthContext to update before navigating
      if ((this.state.loginAttempted || this.state.verificationComplete) && !this.props.isAuth) {
        // console.log("User just authenticated (login or verification), waiting for AuthContext to update before navigation...");
        setTimeout(() => {
          this.props.history.push({
            pathname: destination,
            state: completeState
          });
        }, 100); // Brief delay to allow state propagation
      } else {
        this.props.history.push({
          pathname: destination,
          state: completeState
        });
      }
    }

    this.setState({
      buttonClick: false,
    });
  }

  errRender(errStr, testid) {
    if (!errStr) return;
    return <div data-testid={testid}>{renderErrorMsg(errStr)}</div>;
  }

  toggleCreateAccount() {
    const isRecurringPayment = this.isRecurringTransaction();

    // If recurring payment is selected, account creation is mandatory
    if (isRecurringPayment) {
      return; // Don't allow toggling off when recurring is selected
    }

    this.setState({
      createAccount: !this.state.createAccount,
      // Reset password fields when toggling
      registerInfo: {
        ...this.state.registerInfo,
        pw: "",
        rePw: ""
      },
      confirmPassword: "",
      errorMsg: {
        ...this.state.errorMsg,
        pw: "",
        confirmPassword: "",
        recurringAuth: ""
      }
    });
  }

  toggleAuthMode() {
    const newMode = this.state.authMode === 'login' ? 'signup' : 'login';
    this.setState({
      authMode: newMode,
      errorMsg: {
        ...this.state.errorMsg,
        login: "",
        recurringAuth: ""
      }
    }, () => {
      // After state update, check if we need to auto-enable account creation
      if (newMode === 'signup') {
        this.checkRecurringRequiresAuth();
      }
    });
  }

  handleLoginEmail(e) {
    this.setState({
      loginEmail: e.target.value,
      errorMsg: {
        ...this.state.errorMsg,
        login: ""
      }
    });
  }

  handleLoginPassword(e) {
    this.setState({
      loginPassword: e.target.value,
      errorMsg: {
        ...this.state.errorMsg,
        login: ""
      }
    });
  }

  handleLogin() {
    this.setState({ buttonClick: true });

    const credentials = {
      username: this.state.donorInfo.email,
      password: this.state.loginPassword
    };

    // console.log("Attempting login with email:", this.state.donorInfo.email);

    // Force external API approach to get JWT token for authentication
    // This ensures the request includes x-checkplus-external header and gets JWT token back
    const tempAccessToken = "temp"; // Temporary token to trigger external request headers
    localStorage.setItem("accessToken", tempAccessToken);

    simpleFetch("/donors/login", "POST", credentials, false, { isCustomDomain: false })
      .then((res) => {
        // console.log("Login response status:", res.status);
        // console.log("Login response body:", res.body);

        this.setState({ buttonClick: false });

        if (res.status === 200 || res.status === 204) {
          // Login successful - update authentication state
          this.setState({
            loginAttempted: true,
            errorMsg: {
              ...this.state.errorMsg,
              login: "",
              recurringAuth: ""
            }
          });

          // For status 200: JWT token returned (external request)
          // For status 204: Session-based (internal request)
          if (res.status === 200 && res.body && res.body.accessToken) {
            // Replace temporary token with real JWT token
            localStorage.setItem("accessToken", res.body.accessToken);
            localStorage.setItem("expiredIn", res.body.expiredIn);
            // console.log("Real JWT token stored for external authentication");
          } else {
            // If we didn't get a JWT token, remove the temporary token
            localStorage.removeItem("accessToken");
            localStorage.removeItem("expiredIn");
            // console.log("No JWT token received, removed temporary token");
          }

          // Update global authentication state
          const authObject = { status: true, timestamp: new Date().getTime() };
          localStorage.setItem(DONOR_AUTH, JSON.stringify(authObject));

          // console.log("Login successful - authentication state updated");

          // Chain auto-proceed off the profile fetch so donorInfo is
          // populated before navigation. Skip auto-proceed if the org
          // has custom fields — the overlay collects only email + password.
          this.fetchUserProfile()
            .then(() => {
              if (!this.state.showAuthOverlay) return;
              if (this.hasOrgCustomFields()) {
                this.setState({ showAuthOverlay: false });
                return;
              }
              this.proceedToPayment();
            })
            .catch(() => {
              this.setState({ showAuthOverlay: false });
            });
        } else {
          // Login failed - remove temporary token and show error
          localStorage.removeItem("accessToken");
          localStorage.removeItem("expiredIn");
          // console.log("Login failed with status:", res.status);
          let errorMessage = "Invalid email or password. Please try again.";

          if (res.body && res.body.message) {
            errorMessage = res.body.message;
          } else if (res.status === 422) {
            errorMessage = "Invalid email or password. Please check your credentials.";
          } else if (res.status === 403) {
            errorMessage = "Account not verified. Please check your email for verification link.";
          } else if (res.status === 500) {
            errorMessage = "Server error. Please try again later.";
          }

          this.setState({
            errorMsg: {
              ...this.state.errorMsg,
              login: errorMessage
            }
          });
        }
      })
      .catch((error) => {
        // console.error("Login error:", error);
        // Remove temporary token on error
        localStorage.removeItem("accessToken");
        localStorage.removeItem("expiredIn");
        this.setState({
          buttonClick: false,
          errorMsg: {
            ...this.state.errorMsg,
            login: "Login failed. Please check your connection and try again."
          }
        });
      });
  }

  checkEmailExists(email) {
    if (!email || !checkEmail(email)) {
      return; // Don't check invalid emails
    }

    // console.log("Checking if email exists:", email);

    // Call backend endpoint to check if username (email) exists
    simpleFetch("/donors/username", "POST", { username: email })
      .then((res) => {
        // console.log("Email check response:", res.status);

        if (res.status === 204) {
          // Email exists (204 means user exists)
          const isRecurringPayment = this.isRecurringTransaction();

          this.setState({
            emailCheckComplete: true,
            existingAccountDetected: true,
            showLoginSuggestion: true,
            authMode: 'login',
            loginEmail: email,
            // Automatically show auth overlay for recurring donations
            showAuthOverlay: isRecurringPayment
          });
          // console.log("Existing account detected for email:", email);
          // console.log("Auto-opening login overlay for recurring donation:", isRecurringPayment);
        } else {
          // Email doesn't exist (404 with error message)
          this.setState({
            emailCheckComplete: true,
            existingAccountDetected: false,
            showLoginSuggestion: false
          });
          // console.log("No existing account found for email:", email);
        }
      })
      .catch((error) => {
        // console.log("Email check failed:", error);
        // On error, assume no existing account
        this.setState({
          emailCheckComplete: true,
          existingAccountDetected: false,
          showLoginSuggestion: false
        });
      });
  }

  handleLoginSuggestionAccept() {
    // console.log("User accepted login suggestion");
    this.setState({
      authMode: 'login',
      showLoginSuggestion: false,
      createAccount: false
    });
  }

  handleLoginSuggestionDecline() {
    // console.log("User declined login suggestion");
    // Only set createAccount to true for recurring payments
    // For one-time payments, guest checkout doesn't require account creation
    const isRecurringPayment = this.isRecurringTransaction();
    this.setState({
      showLoginSuggestion: false,
      authMode: 'signup',
      createAccount: isRecurringPayment
    });
  }

  // Seamless registration for recurring donations
  handleSeamlessRegistration() {
    const { firstName, lastName, email, phoneNumber } = this.state.donorInfo;
    const password = this.state.registerInfo.pw;
    const confirmPassword = this.state.confirmPassword;

    // Validation
    if (!firstName || !lastName || !email || !phoneNumber) {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          seamlessReg: "Please fill in all required fields (Name, Email, Phone Number)"
        }
      });
      return;
    }

    if (!checkEmail(email)) {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          seamlessReg: "Please enter a valid email address"
        }
      });
      return;
    }

    if (!isValidPhoneNumber(phoneNumber)) {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          seamlessReg: "Please enter a valid phone number"
        }
      });
      return;
    }

    // Validate password (required)
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])[0-9a-zA-Z]{8,}$/;
    if (!password) {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          pw: "Password is required"
        }
      });
      return;
    }
    if (password.length < 8) {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          pw: "Password must be at least 8 characters"
        }
      });
      return;
    }
    if (!passwordRegex.test(password)) {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          pw: "Password must include letters and numbers"
        }
      });
      return;
    }
    if (password !== confirmPassword) {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          confirmPassword: "Passwords do not match"
        }
      });
      return;
    }

    this.setState({ registrationInProgress: true });

    // Use the required password
    const finalPassword = password;

    // Register user with their transaction details
    // Pass isCustomDomain to ensure we get JWT token in response (external request)
    const organizationId = this.props.location.state &&
                          this.props.location.state.organization &&
                          this.props.location.state.organization.organizationId;

    //console.log("🎨 Registration with organization branding:", {
    //  organizationId: organizationId,
    //  organizationName: this.props.location.state && this.props.location.state.organization && this.props.location.state.organization.organizationName,
    //  hasLogo: this.props.location.state && this.props.location.state.organization && !!this.props.location.state.organization.logo
    //});

    simpleFetch("/donors/register", "POST", {
      username: email,
      password: finalPassword,
      firstName,
      lastName,
      phoneNumber,
      language: this.props.language,
      organizationId: organizationId  // Include organization ID for email branding
    }, false, { isCustomDomain: true })
      .then((res) => {
        this.setState({ registrationInProgress: false });

        // console.log("📋 Registration response:", {
        //  status: res.status,
        //  hasBody: !!res.body,
        //  bodyKeys: res.body ? Object.keys(res.body) : [],
        //  accessToken: (res.body && res.body.accessToken) ? "EXISTS" : "MISSING"
        //});

        if (res.status === 200 || res.status === 204) {
          // Registration successful, verification code sent
          // console.log("Seamless registration successful, verification code sent");

          // Backend returns JWT token for auto-login (status 200)
          if (res.status === 200 && res.body && res.body.accessToken) {
            localStorage.setItem("accessToken", res.body.accessToken);
            localStorage.setItem("expiredIn", res.body.expiredIn);

            // Store verification status if provided (should be false after registration)
            if (res.body.emailVerified !== undefined) {
              localStorage.setItem("emailVerified", res.body.emailVerified.toString());
            }

            // console.log("✅ JWT token received from registration:");
            // console.log("  - User authenticated but unverified");
            // console.log("  - emailVerified:", res.body.emailVerified);
            // console.log("  - Token expiration:", new Date(res.body.expiredIn * 1000).toLocaleString());
            // console.log("  - Message:", res.body.message);
          }

          this.setState({
            verificationCodeSent: true,
            errorMsg: {
              ...this.state.errorMsg,
              seamlessReg: "",
              pw: "",
              confirmPassword: ""
            }
          });
        } else {
          // Registration failed
          const errorMessage = (res.body && res.body.message) || "Registration failed. Please try again.";
          this.setState({
            errorMsg: {
              ...this.state.errorMsg,
              seamlessReg: errorMessage
            }
          });
        }
      })
      .catch((error) => {
        // console.error("Seamless registration error:", error);
        this.setState({
          registrationInProgress: false,
          errorMsg: {
            ...this.state.errorMsg,
            seamlessReg: "Registration failed. Please check your connection and try again."
          }
        });
      });
  }

  handleVerificationCodeChange(e) {
    const value = e.target.value;
    // Only allow numeric input and max 6 digits
    if (/^\d{0,6}$/.test(value)) {
      this.setState({
        verificationCode: value,
        errorMsg: {
          ...this.state.errorMsg,
          verificationCode: ""
        }
      });
    }
  }

  handleVerificationCodeSubmit() {
    if (this.state.verificationCode.length !== 6) {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          verificationCode: "Please enter a valid 6-digit verification code"
        }
      });
      return;
    }

    // Validate password if provided
    const password = this.state.registerInfo.pw;
    const confirmPassword = this.state.confirmPassword;
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])[0-9a-zA-Z]{8,}$/;

    if (password) {
      if (password.length < 8) {
        this.setState({
          errorMsg: {
            ...this.state.errorMsg,
            pw: "Password must be at least 8 characters"
          }
        });
        return;
      }
      if (!passwordRegex.test(password)) {
        this.setState({
          errorMsg: {
            ...this.state.errorMsg,
            pw: "Password must include letters and numbers"
          }
        });
        return;
      }
      if (password !== confirmPassword) {
        this.setState({
          errorMsg: {
            ...this.state.errorMsg,
            confirmPassword: "Passwords do not match"
          }
        });
        return;
      }
    }

    this.setState({ verificationInProgress: true });

    // Prepare request payload - include password if provided during verification
    const payload = {
      code: this.state.verificationCode
    };

    if (password) {
      payload.password = password;
    }

    // console.log("Verifying code with authenticated session (JWT from registration)");
    // console.log("JWT token in localStorage before verification:", localStorage.getItem("accessToken") ? "EXISTS" : "MISSING");
    // console.log("Verification payload:", payload);
    // console.log("Current state - recurringOccurrences:", this.state.recurringOccurrences);
    // console.log("Current state - isInfiniteRecurring:", this.state.isInfiniteRecurring);

    // Verify the code with JWT authentication from registration
    simpleFetch("/donors/verify-code", "POST", payload)
      .then((res) => {
        // console.log("Verification response status:", res.status);
        // console.log("JWT token in localStorage after verification response:", localStorage.getItem("accessToken") ? "EXISTS" : "MISSING");
        this.setState({ verificationInProgress: false });

        if (res.status === 204 || res.status === 200) {
          // Verification successful
          // console.log("Verification successful" + (password ? " with password set" : ""));

          // For status 200: JWT token returned with updated verified status (external requests)
          // For status 204: Session-based verification (internal requests)
          if (res.status === 200 && res.body && res.body.accessToken) {
            // Store updated JWT token with verified status
            localStorage.setItem("accessToken", res.body.accessToken);
            localStorage.setItem("expiredIn", res.body.expiredIn);

            // Store verification status if provided
            if (res.body.emailVerified !== undefined) {
              localStorage.setItem("emailVerified", res.body.emailVerified.toString());
            }

            // console.log("✅ JWT token updated after verification:");
            // console.log("  - emailVerified:", res.body.emailVerified);
            // console.log("  - Token expiration:", new Date(res.body.expiredIn * 1000).toLocaleString());
            // console.log("  - Message:", res.body.message);
          } else {
            // Status 204: Keep existing JWT token from registration
            // console.log("Verification successful (204), using JWT token from registration");
          }

          // Update authentication state
          const authObject = { status: true, timestamp: new Date().getTime() };
          localStorage.setItem(DONOR_AUTH, JSON.stringify(authObject));
          // console.log("DONOR_AUTH set to:", JSON.stringify(authObject));
          // console.log("JWT token still in localStorage after setting DONOR_AUTH:", localStorage.getItem("accessToken") ? "EXISTS" : "MISSING");

          this.setState({
            verificationComplete: true,
            loginAttempted: true,
            errorMsg: {
              ...this.state.errorMsg,
              verificationCode: "",
              recurringAuth: "",
              pw: "",
              confirmPassword: ""
            }
          });

          this.fetchUserProfile()
            .then(() => {
              // console.log("User profile fetched successfully after verification");
              if (this.hasOrgCustomFields()) {
                this.setState({ showAuthOverlay: false });
                return;
              }
              this.proceedToPayment();
            })
            .catch((error) => {
              // console.error("Failed to fetch user profile after verification:", error);
              this.proceedToPayment();
            });
        } else if (res.status === 422) {
          // Validation error from backend
          const errorMessage = (res.body && res.body.message) || "Invalid verification code or password.";

          // Determine which field has the error
          if (errorMessage.includes("password")) {
            this.setState({
              errorMsg: {
                ...this.state.errorMsg,
                pw: errorMessage
              }
            });
          } else {
            this.setState({
              errorMsg: {
                ...this.state.errorMsg,
                verificationCode: errorMessage
              }
            });
          }
        } else {
          // Other verification failures
          const errorMessage = (res.body && res.body.message) || "Invalid verification code. Please try again.";
          this.setState({
            errorMsg: {
              ...this.state.errorMsg,
              verificationCode: errorMessage
            }
          });
        }
      })
      .catch((error) => {
        // console.error("Verification error:", error);
        this.setState({
          verificationInProgress: false,
          errorMsg: {
            ...this.state.errorMsg,
            verificationCode: "Verification failed. Please try again."
          }
        });
      });
  }

  closeAuthOverlay() {
    this.setState({
      showAuthOverlay: false
    });
  }

  // Donors arriving from ExpressPayment (Apple Pay / Google Pay) already
  // authorised a payment method in the wallet sheet, so the payment-method step
  // would be redundant - send them straight to the review screen instead.
  getPaymentDestination() {
    return this.state.fromExpressPayment && this.state.paymentMethod
      ? "/Review"
      : "/SelectPayment";
  }

  // Wallet donors skip /SelectPayment, so without this there is no way to reach the
  // payment-method step from here at all. Choosing a different method discards the
  // wallet approval: it is tied to the method and amount shown in that sheet
  // (CP-253). paymentMethod is cleared too - on this screen the key always holds
  // the donor's own payment method, not the organisation's config.
  onChangePaymentMethodClicked() {
    const {
      // Never carry credentials or PersonalDetails-only validation state onward,
      // matching what onNextBtnClicked strips before navigating.
      createAccount: _createAccount,
      registerInfo: _registerInfo,
      confirmPassword: _confirmPassword,
      confirmEmail: _confirmEmail,
      loginEmail: _loginEmail,
      loginPassword: _loginPassword,
      paymentMethod: _paymentMethod,
      ...state
    } = withoutExpressPaymentAuthorisation(this.state);

    this.props.history.push({ pathname: "/SelectPayment", state });
  }

  proceedToPayment() {
    // Close overlay
    this.setState({ showAuthOverlay: false });

    const cardPaymentsStatus = this.props.location.state && this.props.location.state.cardPaymentsStatus;
    const transfersStatus = this.props.location.state && this.props.location.state.transfersStatus;
    const charges_enabled = this.props.location.state && this.props.location.state.charges_enabled;

    const updatedState = { ...this.state };

    // Validate and ensure organization has complete data
    if (!updatedState.organization) {
      // console.error("Organization object is missing in PersonalDetails");
      updatedState.organization = {
        headerColor: "000000",
        buttonColor: "ffffff",
        organizationName: "Organization",
        logo: {},
        paymentMethodCode: {}
      };
    } else if (!updatedState.organization.paymentMethodCode) {
      // console.warn("paymentMethodCode is missing in organization, using empty object");
      updatedState.organization.paymentMethodCode = {};
    }

    // For QuickPayment flow, ensure we have a valid mission object
    if (updatedState.isQuickPaymentFlow && (!updatedState.mission || !updatedState.mission.title)) {
      updatedState.mission = {
        id: "no-project",
        title: "Quick Payment",
        status: "unlisted",
        donation: true
      };
    }

    // For NoProject flow, ensure we have a valid mission object
    if (updatedState.isNoProjectFlow && (!updatedState.mission || !updatedState.mission.title)) {
      updatedState.mission = {
        id: "no-project",
        title: updatedState.transactionType === 'donation'
          ? `Donation to ${(updatedState.organization && updatedState.organization.organizationName) || "Organization"}`
          : `Payment to ${(updatedState.organization && updatedState.organization.organizationName) || "Organization"}`,
        status: "unlisted",
        donation: updatedState.transactionType === 'donation'
      };
    }

    const isAuthenticated = this.props.isAuth || this.state.loginAttempted || this.state.verificationComplete;
    const completeState = {
      ...updatedState,
      cardPaymentsStatus: cardPaymentsStatus,
      transfersStatus: transfersStatus,
      charges_enabled: charges_enabled,
      isAuth: isAuthenticated,
      userAuthenticated: isAuthenticated,
    };

    // console.log("===== PROCEEDING TO PAYMENT =====");
    // console.log("Authentication flags:");
    // console.log("  - this.props.isAuth:", this.props.isAuth);
    // console.log("  - this.state.loginAttempted:", this.state.loginAttempted);
    // console.log("  - this.state.verificationComplete:", this.state.verificationComplete);
    // console.log("  - Final isAuthenticated:", isAuthenticated);
    // console.log("  - DONOR_AUTH in localStorage:", localStorage.getItem(DONOR_AUTH));
    // console.log("  - accessToken in localStorage:", localStorage.getItem("accessToken"));
    const destination = this.getPaymentDestination();
    // console.log("Navigating to", destination, "with isAuth:", isAuthenticated);

    this.props.history.push({
      pathname: destination,
      state: completeState
    });
  }

  renderRegistration() {
    return;
  }

  // Helper method to check if all required fields are filled for recurring transactions
  isNextButtonDisabled() {
    const isRecurringPayment = this.isRecurringTransaction();
    const isAuthenticated = this.props.isAuth || this.state.loginAttempted || this.state.verificationComplete;

    // For recurring payments
    if (isRecurringPayment && !isAuthenticated) {
      // Check if all required fields are filled before enabling Next button
      const { firstName, lastName, email, phoneNumber, orgName } = this.state.donorInfo;

      // Disable button if any required field is missing
      const namesValid = this.state.isPersonalDonation
        ? (firstName && lastName)
        : !!orgName;
      if (!namesValid || !email || !phoneNumber) {
        return true;
      }

      // Check if phone number is valid
      if (!isValidPhoneNumber(phoneNumber)) {
        return true;
      }

      // All required fields are filled, enable the button so user can click to open overlay
      return false;
    }

    // For recurring payments that are authenticated, check all fields
    if (isRecurringPayment && isAuthenticated) {
      const { firstName, lastName, email, phoneNumber } = this.state.donorInfo;

      if (!firstName || !lastName || !email || !phoneNumber) {
        return true;
      }

      if (!isValidPhoneNumber(phoneNumber)) {
        return true;
      }

      return false;
    }

    // For non-recurring payments, don't disable (use existing validation)
    return false;
  }

  handleCustomFields(e, field) {
    const { customFields, errorMsg } = this.state;
    const { name, value } = e.target;

    let data = customFields;
    data[name] = {
      ...field,
      value,
    };

    let err = errorMsg;
    err[name] = "";

    this.setState({
      customFields: data,
      errorMsg: err,
    });
  }

  handleCustomFieldToggle(fieldId, field) {
    const { customFields, errorMsg } = this.state;
    const currentVal = customFields[fieldId] ? customFields[fieldId].value : 'no';
    const newVal = currentVal === 'yes' ? 'no' : 'yes';

    let data = customFields;
    data[fieldId] = { ...field, value: newVal };

    let err = errorMsg;
    err[fieldId] = "";

    this.setState({ customFields: data, errorMsg: err });
  }

  handleCustomFieldAddress(fieldId, field, subField, subValue) {
    const { customFields, errorMsg } = this.state;
    const currentVal = customFields[fieldId] ? customFields[fieldId].value : '{}';
    let parsed = {};
    try { parsed = JSON.parse(currentVal); } catch (e) { parsed = {}; }

    // When country changes, keep only country and clear address-specific fields
    if (subField === 'country') {
      parsed = { country: subValue };
    } else if (subField === 'region') {
      // When region changes, clear district (cascading reset)
      parsed.region = subValue;
      parsed.district = '';
    } else {
      parsed[subField] = subValue;
    }

    let data = customFields;
    data[fieldId] = { ...field, value: JSON.stringify(parsed) };

    let err = errorMsg;
    err[fieldId] = "";

    this.setState({ customFields: data, errorMsg: err });
  }

  renderCustomFields() {
    const language = this.props.language;

    const customFields = this.props.location.state.organization.formSetting;

    if (
      customFields &&
      customFields.enabled &&
      customFields.rows.length > 0
    ) {
      const rows = customFields.rows.filter(row => !row.archived && !row.internal);

      return rows.map((row) => {
        const labelValue = row.i18n.label[language] ? row.i18n.label[language] : row.i18n.label.en;
        const placeholderValue = row.i18n.placeholder[language] ? row.i18n.placeholder[language] : row.i18n.placeholder.en;

        const value = this.state.customFields[row.id] ? this.state.customFields[row.id].value : "";

        const fieldValue = {
          labelValue,
          placeholderValue,
          value,
        };

        if (row.type === "textarea") {
          return this.renderCustomFieldTextarea(row, fieldValue);
        } else if (row.type === "yesno") {
          return this.renderCustomFieldYesNo(row, fieldValue);
        } else if (row.type === "dropdown") {
          return this.renderCustomFieldDropdown(row, fieldValue);
        } else if (row.type === "address") {
          return this.renderCustomFieldAddress(row, fieldValue);
        } else {
          return this.renderCustomFieldText(row, fieldValue);
        }
      });
    }

    return null;
  }

  getReceiptTooltipText() {
    const languageObj = this.props.languageObj || {};
    return (
      languageObj.subText1 ||
      "Please note the information with the receipt icon will be displayed on your receipt."
    );
  }

  renderCustomFieldText(field, fieldValue) {
    const receiptTooltipText = this.getReceiptTooltipText();
    return (
      <Fragment key={field.id}>
        <div className="PersonalDetails-subheading">
          {fieldValue.labelValue}
          {field.showOnReceipt && (
            <div
              className="PersonalDetails-receiptTooltip"
              data-tooltip={receiptTooltipText}
            >
              <div
                className="PersonalDetails-smallreceiptIcn"
                aria-label={receiptTooltipText}
              ></div>
            </div>
          )}
        </div>

        <div className="PersonalDetails-inputFieldContainer">
          <input
            type="text"
            name={field.id}
            className="PersonalDetails-inputField"
            value={fieldValue.value}
            onChange={e => this.handleCustomFields(e, field)}
            placeholder={fieldValue.placeholderValue}
          />
        </div>

        {this.errRender(this.state.errorMsg[field.id])}
      </Fragment>
    );
  }

  renderCustomFieldTextarea(field, fieldValue) {
    const receiptTooltipText = this.getReceiptTooltipText();
    return (
      <Fragment key={field.id}>
        <div className="PersonalDetails-subheading">
          {fieldValue.labelValue}
          {field.showOnReceipt && (
            <div
              className="PersonalDetails-receiptTooltip"
              data-tooltip={receiptTooltipText}
            >
              <div
                className="PersonalDetails-smallreceiptIcn"
                aria-label={receiptTooltipText}
              ></div>
            </div>
          )}
        </div>

        <div className="PersonalDetails-memotextFieldContainer">
          <textarea
            type="text"
            name={field.id}
            className="PersonalDetails-memotextField"
            value={fieldValue.value}
            onChange={e => this.handleCustomFields(e, field)}
            placeholder={fieldValue.placeholderValue}
          />
        </div>

        {this.errRender(this.state.errorMsg[field.id])}
      </Fragment>
    );
  }

  renderCustomFieldYesNo(field, fieldValue) {
    const receiptTooltipText = this.getReceiptTooltipText();
    const isYes = fieldValue.value === 'yes';
    return (
      <Fragment key={field.id}>
        <div className="PersonalDetails-subheading">
          {fieldValue.labelValue}
          {field.showOnReceipt && (
            <div className="PersonalDetails-receiptTooltip" data-tooltip={receiptTooltipText}>
              <div className="PersonalDetails-smallreceiptIcn" aria-label={receiptTooltipText}></div>
            </div>
          )}
        </div>

        <div
          className="PersonalDetails-yesNoToggle"
          onClick={() => this.handleCustomFieldToggle(field.id, field)}
        >
          <div className={`PersonalDetails-yesNoOption${isYes ? ' PersonalDetails-yesNoOption--active' : ''}`}>
            {this.props.languageObj.yes || 'Yes'}
          </div>
          <div className={`PersonalDetails-yesNoOption${!isYes ? ' PersonalDetails-yesNoOption--active' : ''}`}>
            {this.props.languageObj.no || 'No'}
          </div>
        </div>

        {this.errRender(this.state.errorMsg[field.id])}
      </Fragment>
    );
  }

  renderCustomFieldDropdown(field, fieldValue) {
    const receiptTooltipText = this.getReceiptTooltipText();
    const language = this.props.language;
    const options = field.options || [];
    return (
      <Fragment key={field.id}>
        <div className="PersonalDetails-subheading">
          {fieldValue.labelValue}
          {field.showOnReceipt && (
            <div className="PersonalDetails-receiptTooltip" data-tooltip={receiptTooltipText}>
              <div className="PersonalDetails-smallreceiptIcn" aria-label={receiptTooltipText}></div>
            </div>
          )}
        </div>

        <div className="PersonalDetails-inputFieldContainer">
          <select
            name={field.id}
            className="PersonalDetails-selectField"
            value={fieldValue.value}
            onChange={e => this.handleCustomFields(e, field)}
          >
            <option value="">{fieldValue.placeholderValue || this.props.languageObj.select || '-- Select --'}</option>
            {options.map(opt => {
              const optLabel = opt.label[language] || opt.label.en || '';
              return (
                <option key={opt.id} value={optLabel}>{optLabel}</option>
              );
            })}
          </select>
        </div>

        {this.errRender(this.state.errorMsg[field.id])}
      </Fragment>
    );
  }

  renderCustomFieldAddress(field, fieldValue) {
    const receiptTooltipText = this.getReceiptTooltipText();
    const languageObj = this.props.languageObj || {};
    const language = this.props.language || 'en';
    let parsed = {};
    try { parsed = JSON.parse(fieldValue.value || '{}'); } catch (e) { parsed = {}; }

    const isHK = (parsed.country || 'Hong Kong') === 'Hong Kong';
    const districts = parsed.region ? getDistrictsByRegion(parsed.region) : [];

    const intlFields = [
      { key: 'address1', placeholder: languageObj.addressLine1 || 'Address Line 1' },
      { key: 'address2', placeholder: languageObj.addressLine2 || 'Address Line 2' },
      { key: 'city', placeholder: languageObj.city || 'City' },
      { key: 'state', placeholder: languageObj.stateProvince || 'State / Province' },
      { key: 'postalCode', placeholder: languageObj.postalCode || 'Postal Code' },
    ];

    const hkTextFields = [
      { key: 'street', placeholder: languageObj.streetName || 'Street No. & Name' },
      { key: 'building', placeholder: languageObj.buildingName || 'Building Name' },
      { key: 'block', placeholder: languageObj.blockTower || 'Block / Tower' },
      { key: 'floor', placeholder: languageObj.floor || 'Floor' },
      { key: 'flat', placeholder: languageObj.flatUnit || 'Flat / Unit' },
    ];

    return (
      <Fragment key={field.id}>
        <div className="PersonalDetails-subheading">
          {fieldValue.labelValue}
          {field.showOnReceipt && (
            <div className="PersonalDetails-receiptTooltip" data-tooltip={receiptTooltipText}>
              <div className="PersonalDetails-smallreceiptIcn" aria-label={receiptTooltipText}></div>
            </div>
          )}
        </div>

        <div className="PersonalDetails-inputFieldContainer">
          <select
            className="PersonalDetails-inputField"
            value={parsed.country || 'Hong Kong'}
            onChange={e => this.handleCustomFieldAddress(field.id, field, 'country', e.target.value)}
          >
            {countryList.map(c => (
              <option key={c.value} value={c.value}>{getLabel(c, language)}</option>
            ))}
          </select>
        </div>

        {isHK ? (
          <Fragment>
            <div className="PersonalDetails-inputFieldContainer">
              <select
                className="PersonalDetails-inputField"
                value={parsed.region || ''}
                onChange={e => this.handleCustomFieldAddress(field.id, field, 'region', e.target.value)}
              >
                <option value="">{languageObj.selectRegion || '-- Select Region --'}</option>
                {hkRegions.map(r => (
                  <option key={r.id} value={r.id}>{getLabel(r, language)}</option>
                ))}
              </select>
            </div>

            <div className="PersonalDetails-inputFieldContainer">
              <select
                className="PersonalDetails-inputField"
                value={parsed.district || ''}
                onChange={e => this.handleCustomFieldAddress(field.id, field, 'district', e.target.value)}
                disabled={!parsed.region}
              >
                <option value="">{languageObj.selectDistrict || '-- Select District --'}</option>
                {districts.map(d => (
                  <option key={d.id} value={d.id}>{getLabel(d, language)}</option>
                ))}
              </select>
            </div>

            {hkTextFields.map(sub => (
              <div key={sub.key} className="PersonalDetails-inputFieldContainer">
                <input
                  type="text"
                  className="PersonalDetails-inputField"
                  value={parsed[sub.key] || ''}
                  onChange={e => this.handleCustomFieldAddress(field.id, field, sub.key, e.target.value)}
                  placeholder={sub.placeholder}
                />
              </div>
            ))}
          </Fragment>
        ) : (
          <Fragment>
            {intlFields.map(sub => (
              <div key={sub.key} className="PersonalDetails-inputFieldContainer">
                <input
                  type="text"
                  className="PersonalDetails-inputField"
                  value={parsed[sub.key] || ''}
                  onChange={e => this.handleCustomFieldAddress(field.id, field, sub.key, e.target.value)}
                  placeholder={sub.placeholder}
                />
              </div>
            ))}
          </Fragment>
        )}

        {this.errRender(this.state.errorMsg[field.id])}
      </Fragment>
    );
  }

  renderAuthOverlay() {
    if (!this.state.showAuthOverlay) return null;

    const organization = this.state.organization || {};
    const headerHex = organization.headerColor ? `#${organization.headerColor}` : "#4A9FE9";

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          maxWidth: '500px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
          position: 'relative'
        }}>
          {/* Close button */}
          <button
            onClick={this.closeAuthOverlay}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'transparent',
              border: 'none',
              fontSize: '28px',
              cursor: 'pointer',
              color: '#666',
              lineHeight: '1',
              padding: '4px 8px',
              zIndex: 1
            }}
          >
            ×
          </button>

          {/* Content */}
          <div style={{ padding: '40px 32px 32px' }}>
            {/* Show "Account Found" if existing account detected */}
            {this.state.existingAccountDetected && !this.state.loginAttempted && (
              <>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
                  <h2 style={{ margin: '0 0 12px', color: '#1976D2', fontSize: '24px', fontWeight: '600' }}>
                    Account Found
                  </h2>
                  <p style={{ margin: 0, color: '#666', fontSize: '15px', lineHeight: '1.5' }}>
                    We found an existing account with <strong>{this.state.donorInfo.email}</strong>
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontSize: '14px', fontWeight: '500' }}>
                    Password
                  </label>
                  <input
                    type="password"
                    placeholder="Enter your password"
                    value={this.state.loginPassword}
                    onChange={this.handleLoginPassword}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #E0E0E0',
                      borderRadius: '8px',
                      fontSize: '15px',
                      boxSizing: 'border-box',
                      outline: 'none',
                      transition: 'border-color 0.2s'
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        this.handleLogin();
                      }
                    }}
                  />
                  {this.state.errorMsg.login && (
                    <div style={{ color: '#D32F2F', fontSize: '13px', marginTop: '8px' }}>
                      {this.state.errorMsg.login}
                    </div>
                  )}
                </div>

                <button
                  onClick={this.handleLogin}
                  disabled={!this.state.loginPassword || this.state.buttonClick}
                  style={{
                    width: '100%',
                    padding: '14px',
                    backgroundColor: !this.state.loginPassword || this.state.buttonClick ? '#BDBDBD' : headerHex,
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: !this.state.loginPassword || this.state.buttonClick ? 'not-allowed' : 'pointer',
                    transition: 'background-color 0.2s'
                  }}
                >
                  {this.state.buttonClick ? 'Logging in...' : 'Log In and Continue'}
                </button>
              </>
            )}

            {/* Show "Complete Account Setup" for new users */}
            {!this.state.existingAccountDetected && this.state.emailCheckComplete && !this.state.verificationCodeSent && (
              <>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
                  <h2 style={{ margin: '0 0 12px', color: '#F57C00', fontSize: '24px', fontWeight: '600' }}>
                    Complete Your Account Setup
                  </h2>
                  <p style={{ margin: 0, color: '#666', fontSize: '15px', lineHeight: '1.5' }}>
                    We'll send a verification code to <strong>{this.state.donorInfo.email}</strong> to complete your account setup.
                  </p>
                </div>

                <div style={{
                  backgroundColor: '#F5F5F5',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '20px'
                }}>
                  <p style={{ margin: '0 0 8px', color: '#333', fontSize: '14px', fontWeight: '500' }}>
                    Your details:
                  </p>
                  <p style={{ margin: '4px 0', color: '#666', fontSize: '13px' }}>
                    <strong>Name:</strong> {this.state.donorInfo.firstName} {this.state.donorInfo.lastName}
                  </p>
                  <p style={{ margin: '4px 0', color: '#666', fontSize: '13px' }}>
                    <strong>Email:</strong> {this.state.donorInfo.email}
                  </p>
                  <p style={{ margin: '4px 0', color: '#666', fontSize: '13px' }}>
                    <strong>Phone:</strong> {this.state.donorInfo.phoneNumber}
                  </p>
                </div>

                {/* Password fields (required) */}
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontSize: '14px', fontWeight: '500' }}>
                    Set Password <span style={{ color: '#D32F2F' }}>*</span>
                  </label>
                  <p style={{ margin: '0 0 12px', color: '#666', fontSize: '12px' }}>
                    Create a secure password for your account.
                  </p>
                  <input
                    type="password"
                    placeholder="Create a password (min. 8 characters)"
                    value={this.state.registerInfo.pw}
                    onChange={(e) => this.setRegisterInfoData('pw', e)}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #E0E0E0',
                      borderRadius: '8px',
                      fontSize: '15px',
                      boxSizing: 'border-box',
                      outline: 'none',
                      marginBottom: '12px',
                      transition: 'border-color 0.2s'
                    }}
                  />
                  <input
                    type="password"
                    placeholder="Confirm password"
                    value={this.state.confirmPassword}
                    onChange={this.handConfirmPassword}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #E0E0E0',
                      borderRadius: '8px',
                      fontSize: '15px',
                      boxSizing: 'border-box',
                      outline: 'none',
                      transition: 'border-color 0.2s'
                    }}
                  />
                  {this.state.errorMsg.pw && (
                    <div style={{ color: '#D32F2F', fontSize: '13px', marginTop: '8px' }}>
                      {this.state.errorMsg.pw}
                    </div>
                  )}
                  {this.state.errorMsg.confirmPassword && (
                    <div style={{ color: '#D32F2F', fontSize: '13px', marginTop: '8px' }}>
                      {this.state.errorMsg.confirmPassword}
                    </div>
                  )}
                  <p style={{ margin: '8px 0 0', color: '#999', fontSize: '12px' }}>
                    Password must be at least 8 characters with letters and numbers
                  </p>
                </div>

                <button
                  onClick={this.handleSeamlessRegistration}
                  disabled={this.state.registrationInProgress || !this.state.registerInfo.pw || !this.state.confirmPassword}
                  style={{
                    width: '100%',
                    padding: '14px',
                    backgroundColor: (this.state.registrationInProgress || !this.state.registerInfo.pw || !this.state.confirmPassword) ? '#BDBDBD' : headerHex,
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: (this.state.registrationInProgress || !this.state.registerInfo.pw || !this.state.confirmPassword) ? 'not-allowed' : 'pointer',
                    transition: 'background-color 0.2s'
                  }}
                >
                  {this.state.registrationInProgress ? '⏳ Sending Code...' : '📧 Send Verification Code'}
                </button>

                {this.state.errorMsg.seamlessReg && (
                  <div style={{ color: '#D32F2F', fontSize: '13px', marginTop: '12px', textAlign: 'center' }}>
                    {this.state.errorMsg.seamlessReg}
                  </div>
                )}
              </>
            )}

            {/* Show verification code input after code is sent */}
            {this.state.verificationCodeSent && !this.state.verificationComplete && (
              <>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>📧</div>
                  <h2 style={{ margin: '0 0 12px', color: '#2E7D32', fontSize: '24px', fontWeight: '600' }}>
                    Verification Code Sent
                  </h2>
                  <p style={{ margin: 0, color: '#666', fontSize: '15px', lineHeight: '1.5' }}>
                    We've sent a 6-digit code to <strong>{this.state.donorInfo.email}</strong>
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontSize: '14px', fontWeight: '500' }}>
                    Verification Code
                  </label>
                  <input
                    type="text"
                    placeholder="Enter 6-digit code"
                    value={this.state.verificationCode}
                    onChange={this.handleVerificationCodeChange}
                    maxLength={6}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '2px solid #4CAF50',
                      borderRadius: '8px',
                      fontSize: '24px',
                      textAlign: 'center',
                      letterSpacing: '0.5em',
                      boxSizing: 'border-box',
                      fontWeight: '600',
                      outline: 'none'
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && this.state.verificationCode.length === 6) {
                        this.handleVerificationCodeSubmit();
                      }
                    }}
                  />
                  {this.state.errorMsg.verificationCode && (
                    <div style={{ color: '#D32F2F', fontSize: '13px', marginTop: '8px' }}>
                      {this.state.errorMsg.verificationCode}
                    </div>
                  )}
                </div>

                {/* Password fields during verification - removed since password is now required upfront */}

                <button
                  onClick={this.handleVerificationCodeSubmit}
                  disabled={this.state.verificationCode.length !== 6 || this.state.verificationInProgress}
                  style={{
                    width: '100%',
                    padding: '14px',
                    backgroundColor: this.state.verificationCode.length !== 6 || this.state.verificationInProgress ? '#BDBDBD' : '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: this.state.verificationCode.length !== 6 || this.state.verificationInProgress ? 'not-allowed' : 'pointer',
                    transition: 'background-color 0.2s'
                  }}
                >
                  {this.state.verificationInProgress ? '⏳ Verifying...' : '✓ Verify and Continue'}
                </button>

                <p style={{ textAlign: 'center', fontSize: '12px', color: '#999', marginTop: '16px' }}>
                  Didn't receive the code? Check your spam folder
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (
      this.props.location.state === null ||
      this.props.location.state === undefined
    ) {
      return <this.props.RenderFullPageLoading />;
    }

    this.onScroll = () => {
      if (window.scrollY >= 100) {
        this.setState({ isScrolling: true });
      } else {
        this.setState({ isScrolling: false });
      }
    };

    const organization = this.state.organization || {};
    const isFreePlanFlow =
      this.state.isFreePlanFlow || organization.currentPlan === "free";

    // For free tier: Use organization's actual color for branding (logo), but default CheckPlus blue for UI
    // For paid tier: Use organization's colors for everything
    const resolved = resolveThemeColors(organization.headerColor, organization.buttonColor);
    const headerHex = isFreePlanFlow ? "#4A9FE9" : `#${resolved.headerColor}`;
    const buttonHex = isFreePlanFlow ? "#ffffff" : `#${resolved.buttonColor}`;

    // Original org color for view/header/bg backgrounds
    const originalHeaderHex = organization.headerColor
      ? `#${organization.headerColor}`
      : "#000000";

    // Use organization's actual branding colors for logo (even on free tier)
    const brandingHeaderHex = (organization.orgHeaderColor || organization.headerColor)
      ? `#${organization.orgHeaderColor || organization.headerColor}`
      : headerHex;
    const brandingButtonHex = (organization.orgButtonColor || organization.buttonColor)
      ? `#${organization.orgButtonColor || organization.buttonColor}`
      : buttonHex;

    const viewStyle = isFreePlanFlow
      ? {
        background:
            "linear-gradient(180deg, #eaf4ff 0%, #f7fbff 60%, #ffffff 100%)",
      }
      : { background: originalHeaderHex };

    const headerStyle = isFreePlanFlow ? undefined : { background: originalHeaderHex };
    const smallLogoStyle = isFreePlanFlow ? undefined : { background: originalHeaderHex };

    const isNextDisabled = this.isNextButtonDisabled() || this.state.buttonClick;
    const nextBtnStyle = {
      background: isNextDisabled ? '#BDBDBD' : headerHex,
      color: buttonHex,
      opacity: isNextDisabled ? 0.6 : 1,
      cursor: isNextDisabled ? 'not-allowed' : 'pointer',
    };

    const shouldAnimateEntry = Boolean(this.state.fromMissionDetails);
    const viewClassNames = [];
    if (isFreePlanFlow) {
      viewClassNames.push("PersonalDetails-view", "PersonalDetails-view--free");
    } else {
      viewClassNames.push("PersonalDetails-view");
    }
    const viewClassName = viewClassNames.join(" ");
    const contentClassName = [
      "PersonalDetails-content",
      shouldAnimateEntry ? "PersonalDetails-content--enter" : "",
    ]
      .filter(Boolean)
      .join(" ");
    const headerClassName = isFreePlanFlow
      ? "PersonalDetails-header PersonalDetails-header--free"
      : "PersonalDetails-header";
    const stepsContainerClass = isFreePlanFlow
      ? "PersonalDetails-stepsContainer PersonalDetails-stepsContainer--free"
      : "PersonalDetails-stepsContainer";
    const backContainerClass = isFreePlanFlow
      ? "PersonalDetails-backContainer PersonalDetails-backContainer--free"
      : "PersonalDetails-backContainer";
    const stepTextClass = isFreePlanFlow
      ? "PersonalDetails-stepTxt PersonalDetails-stepTxt--free"
      : "PersonalDetails-stepTxt";
    const indicatorClass = isFreePlanFlow
      ? "PersonalDetails-indicator PersonalDetails-indicator--free"
      : "PersonalDetails-indicator";
    const widthControllerClass = isFreePlanFlow
      ? "PersonalDetails-widthController PersonalDetails-widthController--free"
      : "PersonalDetails-widthController";
    const inputContainerClass = isFreePlanFlow
      ? "PersonalDetails-inputContainer PersonalDetails-inputContainer--free"
      : "PersonalDetails-inputContainer";
    const nextButtonClass = isFreePlanFlow
      ? "PersonalDetails-nextBtn PersonalDetails-nextBtn--free"
      : "PersonalDetails-nextBtn";

    const languageObj = this.props.languageObj;
    const receiptTooltipText = this.getReceiptTooltipText();

    const RenderSwitch = () => {
      if (this.props.isAuth) return null;
      const isPersonal = this.state.isPersonalDonation;
      const onClickSwitch = (value) => {
        const err = {};
        this.setState({
          isPersonalDonation: value === 'individual',
          errorMsg: err,
        });
      };
      return (
        <div>
          <div className="PersonalDetails-toggleSwitch">
            <div
              className={`PersonalDetails-toggleOption${isPersonal ? ' PersonalDetails-toggleOption--active' : ''}`}
              data-testid="personaldetails-payer-type-individual"
              onClick={() => onClickSwitch('individual')}
            >
              {languageObj.personal}
            </div>
            <div
              className={`PersonalDetails-toggleOption${!isPersonal ? ' PersonalDetails-toggleOption--active' : ''}`}
              data-testid="personaldetails-payer-type-company"
              onClick={() => onClickSwitch('company')}
            >
              {languageObj.company}
            </div>
          </div>
          {!isPersonal && (
            <div className="PersonalDetails-bubble">
              <div className="PersonalDetails-bubbleMessage">
                <div className="PersonalDetails-redDot" />
                <div className="PersonalDetails-bubbleText">
                  {languageObj.paymeNote}
                </div>
              </div>
            </div>
          )}
        </div>
      );
    };

    // Create proper logo style based on the type of logo property
    const createLogoStyle = (logo) => {
      if (typeof logo === 'string') {
        // If logo is a URL string, create a backgroundImage style
        return { 
          backgroundImage: `url('${logo}')`, 
          backgroundSize: 'contain', 
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        };
      } else if (typeof logo === 'object') {
        // If logo is already a style object, use it directly
        return logo;
      }
      // Default empty object if logo is undefined or another type
      return {};
    };
    
    const logoStyle = createLogoStyle(organization.logo);
    const organizationLogoUrl =
      typeof organization.logo === "string" ? organization.logo : null;
    const freeHeaderLogoStyle = {
      backgroundColor: brandingHeaderHex, // Use organization's actual branding color
      padding: '12px 20px',
      borderRadius: '16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: '280px',
      width: '100%'
    };

    const renderBackButton = () => (
      <div className={backContainerClass} data-testid="personaldetails-back-btn" onClick={this.onBackBtnClicked}>
        <div className="PersonalDetails-back">
          <div className="PersonalDetails-backBtn" />
          <div className="PersonalDetails-backText">{languageObj.backText}</div>
        </div>
      </div>
    );

    const renderSteps = ({ showBack = true } = {}) => (
      <div className={stepsContainerClass}>
        {showBack ? renderBackButton() : null}
        <div className="PersonalDetails-stepsContent">
          <div className={stepTextClass} data-testid="personaldetails-step-text">
            {this.state.isQuickPaymentFlow || (this.state.mission && this.state.mission.status === "unlisted")
              ? (languageObj.step2of4 || "Step 2 of 4")
              : languageObj.stepTxt}
          </div>
          <div className={indicatorClass}>
            {this.state.isQuickPaymentFlow || (this.state.mission && this.state.mission.status === "unlisted") ? (
              <>
                <div className="PersonalDetails-circle MissionDetails-circleSelected MissionDetails-marginRight" />
                <div className="PersonalDetails-circle MissionDetails-circleSelected MissionDetails-marginRight" />
                <div className="PersonalDetails-circle MissionDetails-circleEmpty MissionDetails-marginRight" />
                <div className="PersonalDetails-circle MissionDetails-circleEmpty" />
              </>
            ) : (
              <>
                <div className="PersonalDetails-circle MissionDetails-circleSelected MissionDetails-marginRight" />
                <div className="PersonalDetails-circle MissionDetails-circleSelected MissionDetails-marginRight" />
                <div className="PersonalDetails-circle MissionDetails-circleSelected MissionDetails-marginRight" />
                <div className="PersonalDetails-circle MissionDetails-circleEmpty MissionDetails-marginRight" />
                <div className="PersonalDetails-circle MissionDetails-circleEmpty" />
              </>
            )}
          </div>
        </div>
        {!isFreePlanFlow && this.state.isScrolling ? (
          <div
            className="PersonalDetails-smallLogoContainer PersonalDetails-fadeIn"
            style={smallLogoStyle}
          >
            <div className="PersonalDetails-logoS" style={logoStyle}></div>
          </div>
        ) : null}
      </div>
    );

    // Donors who arrived via Apple Pay / Google Pay skip /SelectPayment, so this is
    // the only place before the final review screen where they can see - or change -
    // the method that is about to be charged. Renders nothing for everyone else,
    // who chose their method explicitly a step earlier.
    const renderWalletPaymentMethod = () => {
      if (!this.state.fromExpressPayment || !this.state.paymentMethod) return null;

      const methodName = formatWalletPaymentMethod(
        this.state.wallet,
        this.state.brand,
        this.state.last4
      );
      if (!methodName) return null;

      return (
        <div className="PersonalDetails-walletMethod">
          <span className="PersonalDetails-walletMethodLabel">
            {languageObj.payingWith || "Paying with"}
          </span>
          <span className="PersonalDetails-walletMethodName">{methodName}</span>
          <span
            className="PersonalDetails-walletMethodChange"
            onClick={this.onChangePaymentMethodClicked}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") this.onChangePaymentMethodClicked();
            }}
          >
            {languageObj.changePaymentMethod || "Change"}
          </span>
        </div>
      );
    };

    const renderFreeLogoSection = () => {
      if (!isFreePlanFlow) return null;

      return (
        <div className="PersonalDetails-freeHeaderLogoStandalone">
          <div className="PersonalDetails-freeHeaderLogoWrapper">
            {organizationLogoUrl ? (
              <div className="PersonalDetails-freeHeaderLogoInner" style={freeHeaderLogoStyle}>
                <img
                  className="PersonalDetails-freeHeaderLogo"
                  src={organizationLogoUrl}
                  alt={organization.organizationName}
                />
              </div>
            ) : (
              <div
                className="PersonalDetails-freeHeaderLogoFallback"
                style={{
                  ...freeHeaderLogoStyle,
                  color: brandingButtonHex
                }}
              >
                {organization.organizationName}
              </div>
            )}
          </div>
        </div>
      );
    };

    const renderHeader = () => {
      if (isFreePlanFlow) {
        return (
          <div className={headerClassName}>
            <div className="PersonalDetails-freeBrand">
              <span className="PersonalDetails-freeBrandPowered">Powered by</span>
              <img
                src={PLATFORM === "plug" ? plugLogo : checkplusLogo}
                alt={PLATFORM === "plug" ? "Plug" : "CheckPlus for Nonprofits"}
                className="PersonalDetails-freeBrandLogoImage"
              />
            </div>
            <div className="PersonalDetails-freeHeaderSteps">
              {renderSteps({ showBack: false })}
            </div>
            <div className="PersonalDetails-freeHeaderNote">Secure Checkout</div>
          </div>
        );
      }

      return (
        <div className={headerClassName} style={headerStyle}>
          <div className="PersonalDetails-logo" style={logoStyle}>
            {!organization.logo ? "L O G O" : ""}
          </div>
        </div>
      );
    };

    return (
      <div className={viewClassName} style={viewStyle}>
        <Helmet>
          <title>{organization.organizationName}</title>
        </Helmet>
        {renderHeader()}

        <div className={contentClassName}>
          {!isFreePlanFlow && renderSteps()}
          <div className={widthControllerClass}>
            <div className={inputContainerClass}>
              {isFreePlanFlow && (
                <>
                  {renderBackButton()}
                  {renderFreeLogoSection()}
                </>
              )}

              {renderWalletPaymentMethod()}

              {/* For recurring transactions, show email FIRST */}
              {(() => {
                const isRecurringPayment = this.isRecurringTransaction();
                const isAuthenticated = this.props.isAuth || this.state.loginAttempted;

                if (!this.props.isAuth && isRecurringPayment && !isAuthenticated) {
                  return (
                    <>
                      <div
                        className="PersonalDetails-headingText"
                        style={!isFreePlanFlow ? { marginTop: '50px' } : undefined}
                      >
                        {languageObj.headingText}
                      </div>

                      {/* Email Address Section - Show for recurring (toggle hidden for now) */}
                      <div className="PersonalDetails-subheading">
                        {languageObj.subheading[1]}
                        <div
                          className="PersonalDetails-receiptTooltip"
                          data-tooltip={receiptTooltipText}
                        >
                          <div
                            className="PersonalDetails-smallreceiptIcn"
                            aria-label={receiptTooltipText}
                          ></div>
                        </div>
                      </div>

                      <div className="PersonalDetails-inputFieldContainer">
                        <input
                          type="email"
                          className="PersonalDetails-inputField"
                          value={this.state.donorInfo.email}
                          onChange={this.handleEmail}
                          placeholder={languageObj.inputField[2][0]}
                          disabled={this.props.isAuth}
                        />
                      </div>
                      {this.errRender(this.state.errorMsg.email)}

                      {/* Recurring Transaction Account Notice - Show AFTER email */}
                      <div style={{
                        backgroundColor: '#FFF9E6',
                        border: '2px solid #FFA726',
                        borderRadius: '8px',
                        padding: '16px',
                        margin: '16px 0',
                        fontSize: '14px'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '12px'
                        }}>
                          <div style={{
                            fontSize: '24px',
                            flexShrink: 0,
                            lineHeight: '1'
                          }}>
                            ℹ️
                          </div>
                          <div>
                            <div style={{
                              color: '#F57C00',
                              fontWeight: '600',
                              fontSize: '15px',
                              marginBottom: '8px'
                            }}>
                              Account Required for Monthly Recurring {this.state.transactionType === 'payment' ? 'Payments' : 'Donations'}
                            </div>
                            <div style={{
                              color: '#424242',
                              fontSize: '13px',
                              lineHeight: '1.5'
                            }}>
                              To set up your monthly recurring {this.state.transactionType === 'payment' ? 'payment' : 'donation'}, please enter your email address below. We'll check if you have an existing account:
                            </div>
                            <ul style={{
                              margin: '10px 0',
                              paddingLeft: '20px',
                              color: '#424242',
                              fontSize: '13px',
                              lineHeight: '1.5'
                            }}>
                              <li style={{ marginBottom: '6px' }}>
                                <strong>If your account exists:</strong> You'll be prompted to log in with your password
                              </li>
                              <li>
                                <strong>If you're new:</strong> You'll be guided to create a new account
                              </li>
                            </ul>
                            <div style={{
                              color: '#757575',
                              fontSize: '12px',
                              marginTop: '10px',
                              fontStyle: 'italic'
                            }}>
                              An account helps us securely manage your recurring {this.state.transactionType === 'payment' ? 'payments' : 'donations'} and keep you updated.
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Email Status Indicator */}
                      {this.state.emailCheckComplete && this.state.donorInfo.email && (
                        <div style={{
                          padding: '8px 12px',
                          margin: '8px 0',
                          fontSize: '13px',
                          borderRadius: '4px',
                          backgroundColor: this.state.existingAccountDetected ? '#E3F2FD' : '#F0FDF4',
                          border: `1px solid ${this.state.existingAccountDetected ? '#90CAF9' : '#A7F3D0'}`,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          <span style={{ fontSize: '16px' }}>
                            {this.state.existingAccountDetected ? '🔍' : '✨'}
                          </span>
                          <span style={{
                            color: this.state.existingAccountDetected ? '#1565C0' : '#065F46',
                            fontSize: '13px'
                          }}>
                            {this.state.existingAccountDetected
                              ? 'Account found - You\'ll log in with your password'
                              : 'New account - We\'ll send you a verification code'}
                          </span>
                        </div>
                      )}

                      {/* Organization name field - only when Company is selected */}
                      {!this.state.isPersonalDonation && (
                        <div>
                          <div className="PersonalDetails-subheading">
                            {languageObj.subheading[4]}
                            <div
                              className="PersonalDetails-receiptTooltip"
                              data-tooltip={receiptTooltipText}
                            >
                              <div
                                className="PersonalDetails-smallreceiptIcn"
                                aria-label={receiptTooltipText}
                              />
                            </div>
                          </div>

                          <div className="PersonalDetails-inputFieldContainer">
                            <input
                              type="text"
                              className="PersonalDetails-inputField"
                              value={this.state.donorInfo.orgName}
                              onChange={this.handleOrgName}
                              placeholder={languageObj.inputField[5]}
                            />
                          </div>
                          {this.errRender(this.state.errorMsg.orgName)}
                        </div>
                      )}
                    </>
                  );
                }
                return null;
              })()}

              {/* Personal/Company toggle - only for non-authenticated and non-recurring users */}
              {!this.props.isAuth && !this.isRecurringTransaction() && (
                <div>
                  <div
                    className="PersonalDetails-headingText"
                    style={!isFreePlanFlow ? { marginTop: '50px' } : undefined}
                  >
                    {languageObj.headingText}
                  </div>

                  <div className="PersonalDetails-toggleLabel">
                    {this.state.transactionType === 'payment' ? (languageObj.payingAs || 'Paying as') : (languageObj.donatingAs || 'Donating as')}
                  </div>
                  <RenderSwitch />

                  {/* Organization name field - only when Company is selected */}
                  {!this.state.isPersonalDonation && (
                    <div>
                      <div className="PersonalDetails-subheading">
                        {languageObj.subheading[4]}
                        <div
                          className="PersonalDetails-receiptTooltip"
                          data-tooltip={receiptTooltipText}
                        >
                          <div
                            className="PersonalDetails-smallreceiptIcn"
                            aria-label={receiptTooltipText}
                          />
                        </div>
                      </div>

                      <div className="PersonalDetails-inputFieldContainer">
                        <input
                          type="text"
                          className="PersonalDetails-inputField"
                          value={this.state.donorInfo.orgName}
                          onChange={this.handleOrgName}
                          placeholder={languageObj.inputField[5]}
                          data-testid="personaldetails-org-name-input"
                        />
                      </div>
                      {this.errRender(this.state.errorMsg.orgName, 'personaldetails-org-name-error')}
                    </div>
                  )}

                  {/* Name fields - Show BEFORE email for non-recurring */}
                  <div className="PersonalDetails-subheading">
                    {languageObj.subheading[0]}
                    <div
                      className="PersonalDetails-receiptTooltip"
                      data-tooltip={receiptTooltipText}
                    >
                      <div
                        className="PersonalDetails-smallreceiptIcn"
                        aria-label={receiptTooltipText}
                      ></div>
                    </div>
                  </div>

                  <div className="PersonalDetails-inputFieldContainer">
                    <input
                      type="text"
                      className="PersonalDetails-inputField"
                      value={this.state.donorInfo.lastName}
                      onChange={this.handleLastName}
                      placeholder={languageObj.inputField[0]}
                      data-testid="personaldetails-last-name-input"
                    />
                  </div>
                  {this.errRender(this.state.errorMsg.lastName, 'personaldetails-last-name-error')}

                  <div className="PersonalDetails-inputFieldContainer">
                    <input
                      type="text"
                      className="PersonalDetails-inputField"
                      value={this.state.donorInfo.firstName}
                      onChange={this.handleFirstName}
                      placeholder={languageObj.inputField[1]}
                      data-testid="personaldetails-first-name-input"
                    />
                  </div>
                  {this.errRender(this.state.errorMsg.firstName, 'personaldetails-first-name-error')}
                </div>
              )}

              {/* Email Address Section - Only show for non-recurring transactions (recurring shows it at top) */}
              {!this.isRecurringTransaction() && (
                <div className="PersonalDetails-subheading">
                  {languageObj.subheading[1]}
                  <div
                    className="PersonalDetails-receiptTooltip"
                    data-tooltip={receiptTooltipText}
                  >
                    <div
                      className="PersonalDetails-smallreceiptIcn"
                      aria-label={receiptTooltipText}
                    ></div>
                  </div>
                </div>
              )}

              {/* Authentication Complete Component - shown when user is authenticated for recurring */}
              {(() => {
                const isRecurringPayment = this.isRecurringTransaction();
                const isAuthenticated = this.props.isAuth || this.state.loginAttempted;

                if (isRecurringPayment && isAuthenticated) {
                  return (
                    <>
                      <div
                        className="PersonalDetails-headingText"
                        style={!isFreePlanFlow ? { marginTop: '50px' } : undefined}
                      >
                        {languageObj.headingText}
                      </div>

                      <div style={{
                        backgroundColor: '#F0FDF4',
                        border: '1px solid #059669',
                        borderRadius: '8px',
                        padding: '16px',
                        marginTop: '20px',
                        marginBottom: '16px',
                        fontSize: '14px'
                      }}>
                        <div style={{ color: '#059669', fontWeight: '600', fontSize: '15px', marginBottom: '4px' }}>
                          ✓ Authentication Complete
                        </div>
                        <div style={{ color: '#424242', fontSize: '13px', marginBottom: '8px' }}>
                          You're authenticated and ready to proceed with your monthly recurring donation.
                        </div>
                        {this.state.donorInfo.email && (
                          <div style={{
                            color: '#047857',
                            fontSize: '13px',
                            fontWeight: '500',
                            marginTop: '8px',
                            paddingTop: '8px',
                            borderTop: '1px solid #BBF7D0'
                          }}>
                            Signed in as: {this.state.donorInfo.email}
                          </div>
                        )}
                      </div>
                    </>
                  );
                }
                return null;
              })()}

              {/* Email input field - only for NON-RECURRING transactions (recurring shows it at top) */}
              {!this.isRecurringTransaction() && (!((this.state.recurringOccurrences && this.state.recurringOccurrences > 0) || this.state.isInfiniteRecurring) || !(this.props.isAuth || this.state.loginAttempted)) ? (
                <>
                  <div className="PersonalDetails-inputFieldContainer">
                    <input
                      type="email"
                      className="PersonalDetails-inputField"
                      value={this.state.donorInfo.email}
                      onChange={this.handleEmail}
                      placeholder={languageObj.inputField[2][0]}
                      disabled={this.props.isAuth}
                      data-testid="personaldetails-email-input"
                    />
                  </div>
                  {this.errRender(this.state.errorMsg.email, 'personaldetails-email-error')}
                </>
              ) : null}

              {/* Email Status Indicator - Hidden for non-recurring transactions */}
              {/* Authentication is only required for recurring transactions, so we don't show account status for one-time donations */}

              {/* Personal Details Fields - Names (Only for recurring transactions - shown after email) */}
              {!this.props.isAuth && this.isRecurringTransaction() && (
                <>
                  <div className="PersonalDetails-subheading">
                    {languageObj.subheading[0]}
                    <div
                      className="PersonalDetails-receiptTooltip"
                      data-tooltip={receiptTooltipText}
                    >
                      <div
                        className="PersonalDetails-smallreceiptIcn"
                        aria-label={receiptTooltipText}
                      ></div>
                    </div>
                  </div>

                  <div className="PersonalDetails-inputFieldContainer">
                    <input
                      type="text"
                      className="PersonalDetails-inputField"
                      value={this.state.donorInfo.lastName}
                      onChange={this.handleLastName}
                      placeholder={languageObj.inputField[0]}
                      disabled={(() => {
                        const isRecurringPayment = this.isRecurringTransaction();
                        return isRecurringPayment && !this.state.emailCheckComplete;
                      })()}
                    />
                  </div>
                  {this.errRender(this.state.errorMsg.lastName)}

                  <div className="PersonalDetails-inputFieldContainer">
                    <input
                      type="text"
                      className="PersonalDetails-inputField"
                      value={this.state.donorInfo.firstName}
                      onChange={this.handleFirstName}
                      placeholder={languageObj.inputField[1]}
                      disabled={(() => {
                        const isRecurringPayment = this.isRecurringTransaction();
                        return isRecurringPayment && !this.state.emailCheckComplete;
                      })()}
                    />
                  </div>
                  {this.errRender(this.state.errorMsg.firstName)}
                </>
              )}

              {/* For authenticated users, show name fields */}
              {this.props.isAuth && (
                <>
                  <div className="PersonalDetails-subheading" style={!isFreePlanFlow ? { marginTop: '50px' } : undefined}>
                    {languageObj.subheading[0]}
                    <div
                      className="PersonalDetails-receiptTooltip"
                      data-tooltip={receiptTooltipText}
                    >
                      <div
                        className="PersonalDetails-smallreceiptIcn"
                        aria-label={receiptTooltipText}
                      ></div>
                    </div>
                  </div>

                  <div className="PersonalDetails-inputFieldContainer">
                    <input
                      type="text"
                      className="PersonalDetails-inputField"
                      value={this.state.donorInfo.lastName}
                      onChange={this.handleLastName}
                      placeholder={languageObj.inputField[0]}
                      disabled={this.props.isAuth}
                    />
                  </div>
                  {this.errRender(this.state.errorMsg.lastName)}

                  <div className="PersonalDetails-inputFieldContainer">
                    <input
                      type="text"
                      className="PersonalDetails-inputField"
                      value={this.state.donorInfo.firstName}
                      onChange={this.handleFirstName}
                      placeholder={languageObj.inputField[1]}
                      disabled={this.props.isAuth}
                    />
                  </div>
                  {this.errRender(this.state.errorMsg.firstName)}

                  {/* Email field for authenticated recurring users */}
                  {this.isRecurringTransaction() && (
                    <>
                      <div className="PersonalDetails-subheading">
                        {languageObj.subheading[1]}
                        <div
                          className="PersonalDetails-receiptTooltip"
                          data-tooltip={receiptTooltipText}
                        >
                          <div
                            className="PersonalDetails-smallreceiptIcn"
                            aria-label={receiptTooltipText}
                          ></div>
                        </div>
                      </div>

                      <div className="PersonalDetails-inputFieldContainer">
                        <input
                          type="email"
                          className="PersonalDetails-inputField"
                          value={this.state.donorInfo.email}
                          onChange={this.handleEmail}
                          placeholder={languageObj.inputField[2][0]}
                          disabled={this.props.isAuth}
                        />
                      </div>
                      {this.errRender(this.state.errorMsg.email)}
                    </>
                  )}
                </>
              )}

              {/* Phone Number and Note - Always show (including for unauthenticated recurring) */}
              <div className="PersonalDetails-subheading">
                {languageObj.subheading[2]}
                <div
                  className="PersonalDetails-receiptTooltip"
                  data-tooltip={receiptTooltipText}
                >
                  <div
                    className="PersonalDetails-smallreceiptIcn"
                    aria-label={receiptTooltipText}
                  ></div>
                </div>
              </div>

              <div className="PersonalDetails-inputFieldContainer">
                <div className="PersonalDetails-phoneField" data-testid="personaldetails-phone-input">
                  <PhoneInput
                    placeholder={languageObj.inputField[4]}
                    value={this.state.donorInfo.phoneNumber}
                    defaultCountry={"HK"}
                    flags={flags}
                    disabled={(() => {
                      if (this.props.isAuth) return true;
                      const isRecurringPayment = this.isRecurringTransaction();
                      return isRecurringPayment && !this.state.emailCheckComplete;
                    })()}
                    onChange={(phone) => {
                      let obj = this.state.donorInfo;
                      // Store raw E.164 format (no spaces) to avoid react-phone-number-input warnings
                      // The component handles display formatting internally
                      obj.phoneNumber = phone || "";
                      let errorMsg = this.state.errorMsg;
                      errorMsg.phoneNumber = "";
                      this.setState({
                        donorInfo: obj,
                        errorMsg: errorMsg,
                      });
                    }}
                  />
                </div>
              </div>
              {this.errRender(this.state.errorMsg.phoneNumber, 'personaldetails-phone-error')}

              <div className="PersonalDetails-subheading">
                {languageObj.subheading[3]}
                <div
                  className="PersonalDetails-receiptTooltip"
                  data-tooltip={receiptTooltipText}
                >
                  <div
                    className="PersonalDetails-smallreceiptIcn"
                    aria-label={receiptTooltipText}
                  ></div>
                </div>
              </div>

              <div className="PersonalDetails-memotextFieldContainer">
                <textarea
                  type="text"
                  className="PersonalDetails-memotextField"
                  value={this.state.donorInfo.memo}
                  onChange={this.handleMemo}
                  placeholder={languageObj.inputField[3]}
                  data-testid="personaldetails-memo-textarea"
                  disabled={(() => {
                    const isRecurringPayment = this.isRecurringTransaction();
                    return isRecurringPayment && !this.state.emailCheckComplete;
                  })()}
                />
              </div>

              {/* Display donation summary for QuickPayment flow */}
              {this.state.isQuickPaymentFlow && this.state.donations && this.state.donations.length > 0 && (
                <div style={{ marginTop: "30px", marginBottom: "30px" }}>
                  <div className="PersonalDetails-subheading" style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {languageObj.donationSummary || "Donation Summary"}
                  </div>
                  
                  <div style={{ 
                    border: "1px solid #e0e0e0", 
                    borderRadius: "10px", 
                    padding: "15px", 
                    marginTop: "10px",
                    background: "#f9f9f9"
                  }}>
                    {this.state.donations.map((donation, index) => (
                      <div key={index} style={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        padding: "10px 0",
                        borderBottom: index < this.state.donations.length - 1 ? "1px solid #e0e0e0" : "none"
                      }}>
                        <div style={{ fontWeight: "500" }}>
                          {getProjectTitle(this.props.language, donation.mission)}
                        </div>
                        <div style={{ fontWeight: "bold" }}>
                          HK${donation.amount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                        </div>
                      </div>
                    ))}
                    
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      marginTop: "15px", 
                      paddingTop: "15px", 
                      borderTop: "2px solid #e0e0e0",
                      fontWeight: "bold",
                      fontSize: "18px"
                    }}>
                      <div>{languageObj.total || "Total"}</div>
                      <div>HK${this.state.amount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</div>
                    </div>
                  </div>
                </div>
              )}

              {this.renderCustomFields()}

              <div className="PersonalDetails-footer">
                <div
                  className={nextButtonClass}
                  data-testid="personaldetails-next-btn"
                  style={nextBtnStyle}
                  onClick={(e) => {
                    if (!isNextDisabled) {
                      this.onNextBtnClicked(e);
                    }
                  }}
                >
                  {!this.state.buttonClick
                    ? languageObj.nextBtn
                    : languageObj.LoadBtn}
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Auth Overlay */}
        {this.renderAuthOverlay()}
      </div>
    );
  }
}

PersonalDetails.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
  isAuth: PropTypes.bool,
  login: PropTypes.func,
};

export default PersonalDetails;
